import React from 'react';
import { twMerge } from 'tailwind-merge';
import { SPACE } from '@utils/constants';

interface Props extends Pick<React.ComponentProps<'span'>, 'className'> {
  edition: number;
}

export const Ordinal = ({ edition, className }: Props) => {
  return (
    <span
      className={twMerge(
        'font-base text-base-s font-semibold md:text-base-m lg:text-base-l',
        className,
      )}
    >
      #{`${edition}`}
      {SPACE}
    </span>
  );
};
